import OrigemAtendimentoModel from "@/models/origemAtendimentoModel";

import { iServiceCached } from "./base/iServiceCached";

class OrigemAtendimentoService extends iServiceCached<OrigemAtendimentoModel> {
    constructor() {
        super("OrigemAtendimento");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
        }));
    }
}

export default new OrigemAtendimentoService();
